// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1264px){.header-card-col[data-v-8aa4a066]:not(:last-child) .header-card{border-right:2px solid var(--primary-color)}}@media (min-width:1904px){.container-citizen[data-v-8aa4a066]{padding-left:160px!important;padding-right:160px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
